<script lang="ts">
  import Heading from "@shared/svelte/Components/Heading.svelte";
  import ShoppableImage from "@shared/svelte/Components/ShoppableUnit/ShoppableImage.svelte";
  import ShoppableLogo from "@shared/svelte/Components/ShoppableUnit/ShoppableLogo.svelte";
  import Sponsored from "@shared/svelte/Components/ProductLines/Sponsored.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import TrackedLink from "@shared/svelte/Components/Tracking/TrackedLink.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";

  import { EventTracking } from "@shared/services/event_tracking/events";
  import type { HeadingElement } from "@shared/types/Heading";

  export let tagLine: string = "";
  export let tag: HeadingElement = "h3";
  export let logoProps: Record<string, any> = {};
  export let imageProps: Record<string, any> = {};
  export let sponsoredFlag: boolean = false;
  export let forwardLink: string = "";

  const { trackMrcEvents } = EventTracking;

  $: desktopMode = $LayoutStore.isDesktop;
</script>

<style>
  .shoppable-unit-card {
    display: grid;
    gap: 0.75rem;
  }

  header {
    display: flex;
    gap: 0.75rem;
    position: relative;
    overflow-x: hidden;
  }

  .shoppable-content {
    display: grid;
    gap: 0.5rem;
    width: 100%;
  }

  .shoppable-header-bottom {
    display: flex;
    justify-content: space-between;
  }

  @media (min-width: 700px) and (max-width: 1023px) {
    .shoppable-header-bottom {
      align-items: end;
    }
  }
</style>

<TrackingContext let:trackingContext>
  <div class="shoppable-unit-card" use:trackMrcEvents={[trackingContext.entities]}>
    <header>
      <ShoppableLogo {logoProps} {forwardLink} />
      <div class="shoppable-content">
        <Heading
          {tag}
          class={!desktopMode ? `fizz-heading-3` : `fizz-heading-2`}
          style="white-space: break-spaces;"
        >
          {tagLine}
        </Heading>
        <div class="shoppable-header-bottom">
          {#if sponsoredFlag}
            <Sponsored />
          {/if}

          <TrackedLink
            {forwardLink}
            targetObjectType={"shoppable_unit_link"}
            linkText={"View All"}
          />
        </div>
      </div>
    </header>
    <ShoppableImage {imageProps} {forwardLink} />
  </div>
</TrackingContext>
